module.exports = __webpack_public_path__ + "static/media/tag-bg-full.2063ad67.svg";